import styled from "styled-components";
import { Modal } from "ui/base/modal/Modal";
import { defaultThemeColors } from "ui/theme";

const RocketIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/>
        <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/>
        <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/>
        <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/>
    </svg>
);

export const InstructorWelcomeModal = ({ show, handleClose }) => {
    return (
        <Modal show={show} handleClose={handleClose} maxWidth={610} bgColor={defaultThemeColors.secondary} closeBtnColor="#1d1d1f" borderRadius="0.4rem">
            <Container>
                <IconCircle>
                    <RocketIcon />
                </IconCircle>
                <Title>Welcome to Teache!</Title>
                <Description>
                    We're really excited to have you as part of our instructor community. 
                    Your listing is under review, and we'll email you as soon as it's approved and
                    ready for users to book.
                </Description>
                <DarkButton onClick={handleClose}>
                    Back To Home Page
                </DarkButton>
            </Container>
        </Modal>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.25rem;
    padding: 0.5rem 1rem;
    text-align: center;
`;

const IconCircle = styled.div`
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1d1d1f;
`;

const Title = styled.h2`
    font-size: 1.75rem;
    font-weight: 600;
    color: #1d1d1f;
`;

const Description = styled.p`
    font-size: 0.9375rem;
    line-height: 1.6;
    color: #555;
    max-width: 540px;
`;

const DarkButton = styled.button`
    all: unset;
    cursor: pointer;
    background-color: #1d1d1f;
    color: white;
    font-size: 0.9375rem;
    font-weight: 600;
    padding: 14px 36px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.2s ease;
    margin-top: 0.5rem;

    &:hover {
        opacity: 0.85;
    }
`;
